import React from "react";
import LandingPage from "./LandingPage";

const Profile = () => {
  return (
    <div className="profile">
      <LandingPage />
    </div>
  )
}

export default Profile;
